import InlineDateUpdate from './styled';

export default InlineDateUpdate;
